import { render, staticRenderFns } from "./blog-cards-list.vue?vue&type=template&id=4f9f8fc2&"
import script from "./blog-cards-list.vue?vue&type=script&lang=js&"
export * from "./blog-cards-list.vue?vue&type=script&lang=js&"
import style0 from "./blog-cards-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports